import React from 'react';

const SideNavText = ({ children }) => <p className="side-nav-text">{children}</p>;

export default SideNavText;
